import { useState } from "react"
import { AiOutlineAudio, AiOutlineAudioMuted, AiOutlineSend } from "react-icons/ai";

const ChatInput = ({ handleSubmit, disableSubmission, startListening, disableInput, threadId, clientId, planId, placeholder = 'Stat typing' }) => {
    const [textInput, setTextInput] = useState('')

    const disabled = disableSubmission || disableInput
    return (
        <div className="chat-input">
            <form onSubmit={(e) => {
                e.preventDefault()
                console.log({ textInput, threadId, clientId, planId })
                handleSubmit({ textInput, threadId, clientId, planId })
                setTextInput('')
            }}>
                <input type="text" value={textInput} onChange={(e) => setTextInput(e.target.value)} disabled={disabled} placeholder={placeholder} />
                {disableSubmission ? <AiOutlineAudioMuted size={'2rem'} color={'var(--lighterGrey)'} /> : <AiOutlineAudio onClick={startListening} size={'2rem'} />}
                <AiOutlineSend size={'2rem'} color={disableSubmission ? 'var(--lighterGrey)' : 'var(--black)'} onClick={() => !disableSubmission && handleSubmit({ textInput, threadId, clientId, planId })} />
            </form>

        </div>
    )
}

export default ChatInput